<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { getWxConfig, setEncryptedLink, getWxSing } from "./apis/apis";
import moment from "moment";
export default {
  data() {
    return {
      test: "",
      isIos: false,
      mainNo: "",
    };
  },

  methods: {
    // 注入微信解接口
    async initWxConfig(){
      let suData = { url: location.href.split("#")[0] };
      let configData = (await getWxSing(suData)).data.data;
      const changeWxhideAllNonBaseMenuItem = () => {this.$store.commit("changeWxhideAllNonBaseMenuItem", true)}
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: configData.appid, // 必填，公众号的唯一标识
        timestamp: configData.timestamp, // 必填，生成签名的时间戳
        nonceStr: configData.nonceStr, // 必填，生成签名的随机串
        signature: configData.signature, // 必填，签名
        jsApiList: ["hideAllNonBaseMenuItem", "updateAppMessageShareData", "hideMenuItems", "showMenuItems"], // 必填，需要使用的JS接口列表
        success: function (res) {
          // 以键值对的形式返回，可用的api值true，不可用为false
          // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
        },
      });
      wx.ready(function () {
        wx.hideAllNonBaseMenuItem({
          success() {
            changeWxhideAllNonBaseMenuItem();
          }
        });
      });
    }
  },
  watch: {

  },
  mounted() {},
  created() {
    const u = navigator.userAgent;
    this.isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    // this.share();
    this.initWxConfig()
  },
};
</script>

<style lang="less">
#app {
  height: 100%;
}
.detail {
  .van-icon-point {
    width: 7px !important;
    min-width: 7px !important;
    height: 7px !important;
    border-radius: 7px;
    background-color: #639aff;
  }
  .van-cell {
    align-items: center !important;
    padding: 10px 8px 8px 0px;
  }
  .van-cell__right-icon {
    color: #639aff !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue